import store from '../index'
import axios from '@/request/http'
import global from '@/constants/Global.constants'
import router from '../../router/index'
export default {
  state: {
    info: '',
    permission: {},
    permissionList: []
  },
  mutations: {
    getInfo (state, token) {
      state.info = {
        role: 'superAdmin',
        permissions: '超级管理员'
      }
      sessionStorage.setItem('info', JSON.stringify(store.getters.info))
    },
    // setRole (state, options) {
    //   state.info = {
    //     role: options.role,
    //     permissions: options.permissions
    //   }
    //   sessionStorage.setItem('info', JSON.stringify(store.getters.info))
    //   store.dispatch('newRoutes', options.role)
    //   router.addRoutes(store.getters.addRouters)
    // },
    initPermission (state, permissionList) {
      state.permissionList = permissionList
    },
    getPermission (state, menuId) {
      let permission = state.permissionList.find(item => item.menuId == menuId)
      if (permission) {
        permission.functIds.forEach(item => {
          permission[item] = true
        })
      }
      state.permission = permission
    },
  },
  actions: {
    getInfo ({commit}, token) {
      commit('getInfo', token)
    },
    // setRole ({commit}, options) {
    //   commit('setRole', options)
    // },
    initPermission ({commit}) {
      let user = JSON.parse(localStorage.getItem('user'))
      axios.post(global.BASE_ACL + '/auth/findFunction?userInfoId='+ user.userInfoId + '&systemId=' + user.systemId).then(res => {
        commit('initPermission', res.data.data)
      })
    },
    getPermission ({commit}, menuId) {
      commit('getPermission', menuId)
    },
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/role.js